// extracted by mini-css-extract-plugin
export default {"h1":"ce8857a5c46d4e321680b4d6922dcce7-scss","h2":"_5f038ec381db6fcbd7253125940986da-scss","h4":"_74a232a6672acf19fb9820be4be10405-scss"};